import React from 'react';
import _ from 'lodash';
import BaseUILibButton from '../button/button';
import TrashCan from '../icons/trashCan.svg.js';
import GreaterThan from '../icons/greaterThan-svg.js';

function onClick1() {
  this.updateMonth(-1);
}

function onClick2() {
  this.updateMonth(1);
}

function repeatDay3(dates, currentMonth, day, dayIndex) {
  return /*#__PURE__*/React.createElement("td", {
    key: day + dayIndex
  }, /*#__PURE__*/React.createElement("div", {
    className: "dp-day-name"
  }, day));
}

function onClick4(dates, currentMonth, week, weekIndex, weekId, day) {
  var date = dates[7 * week + day];

  if (!this.props.validateDate || this.props.validateDate(date)) {
    this.props.onChange(date);
  }
}

function repeatDay5(dates, currentMonth, week, weekIndex, weekId, day, dayIndex) {
  return /*#__PURE__*/React.createElement("td", {
    onClick: onClick4.bind(this, dates, currentMonth, week, weekIndex, weekId, day, dayIndex),
    key: weekId + '_' + dayIndex
  }, /*#__PURE__*/React.createElement("div", {
    className: this.getElementClasses(dates[7 * week + day])
  }, dates[7 * week + day] ? dates[7 * week + day].getDate() : ''));
}

function scopeWeekId6(dates, currentMonth, week, weekIndex) {
  var weekId = dates[7 * week].getFullYear() + '_' + dates[7 * week].getMonth() + '_' + week;
  return React.createElement.apply(this, ['tr', {
    className: 'dp-week',
    key: weekId
  }, _.map(_.range(7), repeatDay5.bind(this, dates, currentMonth, week, weekIndex, weekId))]);
}

function repeatWeek7(dates, currentMonth, week, weekIndex) {
  return scopeWeekId6.apply(this, [dates, currentMonth, week, weekIndex]);
}

function scopeDatesCurrentMonth8() {
  var dates = this.getDatesInMonth();
  var currentMonth = this.state.value.getMonth();
  return /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("thead", null, React.createElement.apply(this, ['tr', {}, _.map(this.getDays(), repeatDay3.bind(this, dates, currentMonth))])), React.createElement.apply(this, ['tbody', {}, _.map(_.range(dates.length / 7), repeatWeek7.bind(this, dates, currentMonth))]));
}

function onClick9() {
  this.props.onChange(null);
}

function onClick10() {
  var today = new Date();

  if (!this.props.validateDate || this.props.validateDate(today)) {
    this.setState({
      value: new Date()
    });
  }
}

function onClick11() {
  if (this.props.value) {
    this.setState({
      value: this.props.value
    });
  }
}

export default function () {
  return /*#__PURE__*/React.createElement("div", {
    className: this.props.getClassName('control-date-picker'),
    "data-aid": this.props.automationId,
    "data-hook": this.props.dataHook
  }, /*#__PURE__*/React.createElement("div", {
    className: "dp-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dp-navigate dp-previous",
    onClick: onClick1.bind(this)
  }, /*#__PURE__*/React.createElement(GreaterThan, null)), /*#__PURE__*/React.createElement("div", {
    className: "dp-title"
  }, this.getMonthTitle()), /*#__PURE__*/React.createElement("div", {
    className: "dp-navigate dp-next",
    onClick: onClick2.bind(this)
  }, /*#__PURE__*/React.createElement(GreaterThan, null))), /*#__PURE__*/React.createElement("div", {
    className: "dp-body"
  }, scopeDatesCurrentMonth8.apply(this, [])), /*#__PURE__*/React.createElement("div", {
    className: 'dp-footer' + (this.props.showDelete ? ' with-delete-btn' : '')
  }, this.props.showDelete ? /*#__PURE__*/React.createElement(BaseUILibButton, {
    className: "delete-btn",
    key: "deleteButton",
    onClick: onClick9.bind(this)
  }, /*#__PURE__*/React.createElement(TrashCan, null)) : null, /*#__PURE__*/React.createElement(BaseUILibButton, {
    className: "goto-today",
    disabled: this.props.validateDate && !this.props.validateDate(new Date()),
    onClick: onClick10.bind(this)
  }, /*#__PURE__*/React.createElement("span", null, this.props.todayLabel)), /*#__PURE__*/React.createElement(BaseUILibButton, {
    className: "goto-selection",
    disabled: !this.props.value,
    onClick: onClick11.bind(this)
  }, /*#__PURE__*/React.createElement("span", null, this.props.goToSelectedLabel))));
}